import React from 'react';
import { reviews } from '../../data/mockData';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiStar } = FiIcons;

const Testimonials = () => {
  return (
    <section className="py-24 md:py-32 bg-luma-bg overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-20">
          <span className="text-luma-primary text-[10px] font-bold tracking-[0.3em] uppercase mb-4 block">Parent Perspectives</span>
          <h2 className="font-serif text-4xl md:text-5xl text-luma-text">Stories from <span className="italic">our village</span>.</h2>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16">
          {reviews.map((review) => (
            <div key={review.id} className="relative">
              <div className="text-[120px] font-serif text-luma-sand/30 absolute -top-16 -left-4 leading-none select-none">“</div>
              <div className="relative z-10 pt-8">
                <div className="flex gap-1 mb-8">
                  {[...Array(review.rating)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="fill-luma-primary text-luma-primary text-xs" />
                  ))}
                </div>
                <p className="text-xl md:text-2xl font-serif text-luma-text/80 leading-relaxed italic mb-10">
                  {review.content}
                </p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-luma-sand/50 flex items-center justify-center font-serif text-xl text-luma-primary">
                    {review.name[0]}
                  </div>
                  <div>
                    <h4 className="font-bold text-xs uppercase tracking-widest text-luma-text">{review.name}</h4>
                    <p className="text-[10px] uppercase tracking-widest text-luma-text/40 font-bold">{review.role} • {review.location}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;